/* FIXME: Migrate to typescript */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import { useCallback, useEffect, useReducer, useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styled from '@emotion/styled';
// FIXME: TODO: remove direct use of @reach/accordion and use hotsauce instead
// Also, uninstall the dependecy from this @hotjar/checkout package
import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from '@reach/accordion';

import { Icon } from '@hotjar/webapp/components/Icon';
import { Tooltip } from '@hotjar/webapp/components/Tooltip';
import { ErrorMessage } from '@hotjar/webapp/components/Message';
import { api as paymentMethodAPIV1 } from '@hotjar/webapp/billing/paymentMethod';
import { prettifyPriceWithCurrencySymbol } from '@hotjar/webapp/billing/cost';
import { subscriptionAPI } from '@hotjar/webapp/billing/subscription';
import { tokens, Loader, Button } from '@hotjar/hotsauce';

import { ValidationError } from '@hotjar/webapp/billing/payment';
import { COUNTRIES } from '@hotjar/country-lib';
import { useSettings } from '@hotjar/webapp/hooks/useSettings';

import { useTranslationWithPrefix } from '@hotjar/translations';
import { paymentMethodAPI } from '@hotjar/webapp/domains/billing/paymentMethod';

import { useTrack } from '@hotjar/webapp/hooks/useTrack';

import { AddPayment } from '../PaymentDetails/Payments/AddPayment';
import {
  Reducer,
  initialState,
  ACTIONS,
  YearlyUpsellModalState,
} from '../PaymentDetails/Payments/Reducer';
import {
  onValidationError,
  ValidateFields,
  OnUpsertError,
  SubmitPaymentMethod,
  OnSuccess,
} from '../PaymentDetails/Payments/utils';
import { getErrorMessageTranslationKey } from '../braintree/error-messages';
import { setupHostedFields } from '../braintree/hosted-fields';
import { setupPaypal } from '../braintree/paypal';

const MainContent = styled.div`
  padding: ${tokens.spacer.x4} ${tokens.spacer.x3} ${tokens.spacer.x1} ${tokens.spacer.x3};
  font-weight: normal;
  font-size: 12px;
`;

const TitleContainer = styled.div`
  margin-bottom: ${tokens.spacer.x4};

  > *:not(:last-child) {
    margin-bottom: ${tokens.spacer.x2};
  }
`;
const Title = styled.div`
  font-size: 28px;
`;
const Subtitle = styled.div`
  font-size: 14px;
`;
const SavingsBox = styled.span`
  padding: 6px 8px;
  background: ${tokens.color.bg_success};
  border-radius: 2px;
  color: ${tokens.color.text_success};
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
`;

const UpgradeSummary = styled.div`
  margin-bottom: ${tokens.spacer.x4};

  > *:not(:last-child) {
    margin-bottom: ${tokens.spacer.x1};
  }
`;
const UpgradeSummaryTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
`;

const Pill = styled.div`
  border: 1px solid ${tokens.color.ui_border_light};
  border-radius: 4px;
  padding: ${tokens.spacer.x2};

  > *:not(:last-child) {
    margin-bottom: ${tokens.spacer.x1};
  }
`;
const PillHeader = styled.div`
  font-weight: bold;
  color: ${tokens.color.text_light};
  text-transform: uppercase;
`;
const PillLine = styled.div`
  display: flex;
  justify-content: space-between;
`;

const AccordionHeading = styled.div`
  display: flex;
  justify-content: space-between;
`;

const AccordionContent = styled(AccordionPanel)``;
const SavingsLine = styled(PillLine)`
  color: ${tokens.color.text_success};
`;
const PillDivider = styled(PillLine)`
  border-bottom: 1px solid ${tokens.color.ui_border_light};
`;
const TotalLine = styled(PillLine)`
  font-size: 14px;
`;

const PillLineDescription = styled.div``;
const PillLineTotal = styled.div``;

const LegalText = styled.div`
  padding: ${tokens.spacer.x0} ${tokens.spacer.x1};
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

const Link = styled.span`
  text-decoration: underline;
  color: ${tokens.color.text_light};
  cursor: pointer;
`;

const BlueLink = styled(AccordionButton)`
  color: ${tokens.color.link};
  background-color: unset;
  border: unset;
  line-height: ${tokens.spacer.x2};
  letter-spacing: 0.1px;
`;

const StyledAccordionItem = styled(AccordionItem)`
  > [data-reach-accordion-panel] {
    &:focus {
      outline: none;
    }
  }
`;

/**
 * We need to use the display property to hide the paypal div
 * so that it exists in the DOM (while not visible to the user) when setting up paypal.
 */
const Paypal = styled.div`
  display: ${({ showPaypal }) => (showPaypal ? 'unset' : 'none')};
  width: 250px;
`;

const PaymentMethodDetail = styled.div`
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.1px;
  color: ${tokens.color.text_default};
`;

const PaymentMethodHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  display: ${({ isLoading }) => (isLoading ? 'none' : 'unset')};
`;

const translateWithPrefix = (t) => (prefix) => (key) => t(`${prefix}.${key}`);

const PaymentMethodPill = ({
  state,
  setExpanded,
  onPaymentTypeChanged,
  onVerificationsFieldsChanged,
  countries,
  onPaypalLogout,
}) => {
  const { t } = useTranslation('common');
  const trans = translateWithPrefix(t)('yearly-upsell.upgrade-summary.payment-method');

  // We set the fist item to be expanded since accordions work on indices
  const index = state.expanded ? 0 : null;

  return (
    <Pill>
      <Accordion index={index} onChange={setExpanded}>
        <StyledAccordionItem>
          <AccordionHeading>
            <PaymentMethodHeader>
              <PillHeader>{trans('header')}</PillHeader>
              {state.paymentMethod?.type === 'credit_card' && (
                <PaymentMethodDetail>
                  Credit Card: xxxx xxxx xxxx {state.paymentMethod.label}
                </PaymentMethodDetail>
              )}
              {state.paymentMethod?.type === 'paypal' && (
                <PaymentMethodDetail>Paypal: {state.paymentMethod.label}</PaymentMethodDetail>
              )}
            </PaymentMethodHeader>
            <BlueLink>
              {state.paymentMethod?.available && (
                <>
                  {trans('change-link')} &nbsp;
                  <Icon
                    size="12"
                    color={tokens.color.azure}
                    icon={state.expanded ? 'caret-up' : 'caret-down'}
                  />
                </>
              )}
            </BlueLink>
          </AccordionHeading>
          <AccordionContent>
            <AddPayment
              state={state}
              onPaymentTypeChanged={onPaymentTypeChanged}
              onVerificationsFieldsChanged={onVerificationsFieldsChanged}
              countries={countries}
              onPaypalLogout={onPaypalLogout}
            />
          </AccordionContent>
        </StyledAccordionItem>
      </Accordion>
    </Pill>
  );
};

const CostSummaryPill = ({ currencySymbol, priceSummary }) => {
  const { t } = useTranslation('common');
  const prettifyPrice = prettifyPriceWithCurrencySymbol(currencySymbol);

  const trans = translateWithPrefix(t)('yearly-upsell.upgrade-summary.cost-breakdown');

  let proRataPill;

  const proRata = priceSummary.charge.deductions.find(
    (deduction) => deduction.id === 'PRORATED_DEDUCTION',
  );

  if (proRata) {
    const tooltipContent = trans('pro-rata-tooltip');

    proRataPill = (
      <SavingsLine>
        <PillLineDescription>
          Pro rata deduction&nbsp;
          <Tooltip content={tooltipContent} appendTo="parent">
            <span
              // FIXME: jsx-a11y/no-noninteractive-tabindex
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              tabIndex="0"
            >
              <Icon icon="info" size={12} color={tokens.color.text_success} />
            </span>
          </Tooltip>
        </PillLineDescription>
        <PillLineTotal>- {prettifyPrice(proRata.amount)}</PillLineTotal>
      </SavingsLine>
    );
  }

  const {
    subtotal,
    discountPercentage,
    discountTotal,
    tax: { rate: taxRate, amount: taxAmount },
    totalWithTax,
  } = priceSummary.charge;

  return (
    <Pill>
      <PillHeader>{trans('header')}</PillHeader>
      <PillLine>
        <PillLineDescription>{trans('yearly')}</PillLineDescription>
        <PillLineTotal>{prettifyPrice(subtotal)}</PillLineTotal>
      </PillLine>
      <SavingsLine>
        <PillLineDescription>
          {trans('savings')} ({discountPercentage}%)
        </PillLineDescription>
        <PillLineTotal>- {prettifyPrice(discountTotal)}</PillLineTotal>
      </SavingsLine>
      {proRataPill}
      <PillLine>
        <PillLineDescription>VAT ({taxRate}%)</PillLineDescription>
        <PillLineTotal>{prettifyPrice(taxAmount)}</PillLineTotal>
      </PillLine>
      <PillDivider />
      <TotalLine>
        <PillLineDescription>{trans('total')}</PillLineDescription>
        <PillLineTotal>{prettifyPrice(totalWithTax)}</PillLineTotal>
      </TotalLine>
    </Pill>
  );
};

export const YearlyUpsellOwnerContent = ({
  currencySymbol,
  state,
  onSubmit = () => {},
  onContactSupport = () => {},
  onPaypalLogout,
  setExpanded,
  onPaymentTypeChanged,
  onVerificationsFieldsChanged,
  countries,
}) => {
  const { t } = useTranslation('common');

  const isLoading = state.loadingState === YearlyUpsellModalState.loading;
  const isSubmitting = state.loadingState === YearlyUpsellModalState.submitting;
  const isError = state.loadingState === YearlyUpsellModalState.error;
  const hasOneTimeDiscount = !!state.priceSummary.charge.deductions.find(
    (deduction) => deduction.id === 'ADDITIONAL_ANNUAL_DEDUCTION',
  );

  const {
    discountPercentage: updatedDiscountPercentage,
    discountTotal: updatedDiscountTotal,
    totalWithTax: updatedTotalWithTax,
  } = state.priceSummary.charge;
  const { discountPercentage: futureDiscountPercentage, totalWithTax: futureTotalWithTax } =
    state.priceSummary.future;

  const prettifyPrice = prettifyPriceWithCurrencySymbol(currencySymbol);

  const prettyDiscountTotal = prettifyPrice(updatedDiscountTotal);
  const prettyUpdatedTotalWithTax = prettifyPrice(updatedTotalWithTax);
  const prettyFutureTotalWithTax = prettifyPrice(futureTotalWithTax);

  return (
    <MainContent>
      <Loader isLoading={isLoading} />
      {isError && <ErrorMessage>{state.errorMessage}</ErrorMessage>}
      {!isError && (
        <Content isLoading={isLoading}>
          <TitleContainer>
            <Title>
              <Trans i18nKey="yearly-upsell.title">
                Switch to yearly and get <strong>{{ updatedDiscountPercentage }}% off</strong>
              </Trans>
            </Title>
            {hasOneTimeDiscount && (
              <Subtitle>
                <Trans i18nKey="yearly-upsell.subtitle">
                  Update by June 30th to get {{ updatedDiscountPercentage }}% off on your first year
                  (that’s 3 months free), and {{ futureDiscountPercentage }}% off every year after
                </Trans>
              </Subtitle>
            )}
            <SavingsBox>
              <Trans i18nKey="yearly-upsell.savings-box">
                You save {{ prettyDiscountTotal }} in total
              </Trans>
            </SavingsBox>
          </TitleContainer>
          <UpgradeSummary>
            <UpgradeSummaryTitle>{t('yearly-upsell.upgrade-summary.title')}</UpgradeSummaryTitle>
            {state.errorMessage && <ErrorMessage>{state.errorMessage}</ErrorMessage>}
            <PaymentMethodPill
              state={state}
              setExpanded={setExpanded}
              onPaymentTypeChanged={onPaymentTypeChanged}
              onVerificationsFieldsChanged={onVerificationsFieldsChanged}
              countries={countries}
              onPaypalLogout={onPaypalLogout}
            />
            <CostSummaryPill currencySymbol={currencySymbol} priceSummary={state.priceSummary} />
            <LegalText>
              <Trans
                i18nKey="yearly-upsell.upgrade-summary.legal-text"
                values={{ prettyUpdatedTotalWithTax, prettyFutureTotalWithTax }}
              />
            </LegalText>
          </UpgradeSummary>
          <Footer>
            <div>
              <div>{t('yearly-upsell.footer.help-text')}</div>
              <div>
                {/* FIXME: jsx-a11y/anchor-is-valid */}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link onClick={onContactSupport}>{t('yearly-upsell.footer.contact-support')}</Link>
              </div>
            </div>
            {state.paymentType === 'paypal' && !state.isPaypalLoggedIn ? null : (
              <Button isLoading={isSubmitting} size="l" onClick={onSubmit}>
                {t('yearly-upsell.footer.submit-button')}
              </Button>
            )}
            <Paypal showPaypal={state.paymentType === 'paypal' && !state.isPaypalLoggedIn}>
              <div id="modal-payment-form-paypal-button" />
            </Paypal>
          </Footer>
        </Content>
      )}
    </MainContent>
  );
};

export const YearlyUpsellOwner = ({ account, onSubmit, onContactSupport }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  const { withContext, paymentOrigins } = useTrack();
  const { t: tBilling } = useTranslationWithPrefix('billing:payment-details');

  const { data: settings } = useSettings();
  const sanctionedCountries = settings?.sanctioned_countries;
  const currencySymbols = settings?.currency_symbols;

  const countries = useMemo(
    () =>
      COUNTRIES.filter(
        ({ value }) =>
          !sanctionedCountries?.find((sanctionedCountry) => sanctionedCountry.code === value),
      ),
    [sanctionedCountries],
  );

  const onPaymentTypeChanged = (paymentType) =>
    dispatch({ type: ACTIONS.PAYMENT_TYPE_CHANGED, payload: { paymentType } });

  const onVerificationsFieldsChanged = (verificationFields) => {
    dispatch({ type: ACTIONS.VERIFICATION_FIELDS_CHANGED, payload: { verificationFields } });
  };

  const onPaypalLogout = () => dispatch({ type: ACTIONS.ON_PAYPAL_LOGOUT });

  const setCardType = ({ type, accepted }) => {
    dispatch({ type: ACTIONS.SET_CARD_TYPE, payload: { type, accepted } });
  };

  const onExpandedToggled = () => dispatch({ type: ACTIONS.ON_EXPAND_TOGGLE });
  const submit = useCallback(() => {
    if (state.loadingState !== YearlyUpsellModalState.submitting) {
      dispatch({ type: ACTIONS.ON_SUBMIT });

      const submitPayment = () => {
        if (state.expanded) {
          /* We have a payment method existing but made payment changes or
           * we don't have a payment method set (in this case the user has to enter
           * payment details)
           */
          return SubmitPaymentMethod({ state })
            .then(
              (paymentMethod) => [paymentMethod, undefined],
              (validationError) => [undefined, validationError.errorFields],
            )
            .then(([paymentMethod = undefined, errorFields = []] = []) => {
              // Combine failed validation fields with any local fields
              // which failed validation and show these errors
              const combinedInvalidFields = errorFields.concat(ValidateFields(state));
              if (combinedInvalidFields.length) {
                throw new ValidationError('Failed to validate fields', combinedInvalidFields);
              }
              // clear formfield errors
              dispatch({ type: ACTIONS.ON_VALIDATION_SUCCESS });
              return paymentMethod;
            })
            .then((paymentMethod) => paymentMethodAPI.vaultCard(account.id, paymentMethod))
            .then((paymentMethod) => OnSuccess(paymentMethod, account));
        }
        // Account has existing payment method and no changes in payment method simply return
        // existing method
        return Promise.resolve(state.paymentMethod);
      };

      withContext({ origin: paymentOrigins.yearlyUpsell }, () =>
        submitPayment()
          .then((paymentMethod) => onSubmit({ account, paymentMethod }))
          .then(undefined, (error) =>
            OnUpsertError(error, dispatch, account, (message) =>
              tBilling(getErrorMessageTranslationKey(message)),
            ),
          )
          .finally(() => dispatch({ type: ACTIONS.ON_SUBMIT_COMPLETE })),
      );
    }
  }, [state, account, onSubmit, tBilling, withContext, paymentOrigins]);

  useEffect(() => {
    Promise.all([
      paymentMethodAPIV1.get(account),
      subscriptionAPI.preview(account, [], 'yearly_recurring'),
      setupHostedFields({
        accountId: account.id,
        formId: 'credit-card-fields',
        onValidationError: (invalidFieldKeys) =>
          onValidationError({ invalidFieldKeys, dispatch, account }),
        onCardValidChange: setCardType,
      }),
      setupPaypal({
        accountId: account.id,
        paypalButtonId: 'modal-payment-form-paypal-button',
        onPaypalLogin: (token) => {
          dispatch({ type: ACTIONS.SET_PAYPAL_LOGIN_DETAILS, payload: { token } });
        },
        style: { color: 'blue', label: 'checkout', height: 55 },
      }),
    ]).then(
      ([paymentMethod, priceSummary, hostedFields]) => {
        dispatch({
          type: ACTIONS.ON_LOAD_SUCCESS,
          payload: { paymentMethod, priceSummary, hostedFields },
        });
      },
      (error) => {
        dispatch({ type: ACTIONS.ON_LOAD_FAILURE, payload: { errorMessage: error.message } });
      },
    );
  }, [account]);

  const currencyCode = account.currency;
  const currencySymbol = currencySymbols?.[currencyCode];

  if (!currencySymbol) {
    return null;
  }

  return (
    <YearlyUpsellOwnerContent
      currencySymbol={currencySymbol}
      onSubmit={submit}
      onContactSupport={onContactSupport}
      account={account}
      state={state}
      setExpanded={onExpandedToggled}
      onPaymentTypeChanged={onPaymentTypeChanged}
      onVerificationsFieldsChanged={onVerificationsFieldsChanged}
      onPaypalLogout={onPaypalLogout}
      countries={countries}
    />
  );
};
